import { fixedsHeader, initSearch, globalSearch, initFancyBox } from "@common/utils/initUtils";
import { lazyLoad, ImportBundle } from "@common/utils/utils";
import Swiper from "swiper11";
import { Navigation, Pagination, Autoplay } from "swiper11/modules";
import footer1_Init from "@common/components/footer-1";
$(function () {
  if (window.innerWidth === 1350 || window.innerWidth === 412) {
    $(document).one("mousemove", () => {
      initFunction();
    });
    $(document).one("scroll", () => {
      initFunction();
    });
  } else {
    initFunction();
  }
});

function initFunction() {
  ImportBundle({ type: "css", onlyIndex: true }, [
    "https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css",
    "https://static.yigetechcms.com/public/css/animate.min.css",
    "https://static.yigetechcms.com/public/css/fancybox@5.0.0.min.css",
  ]);
  ImportBundle({ type: "js", onlyIndex: true }, [
    {
      src: "https://static.yigetechcms.com/public/js/wow.min.js",
      fn: () => {
        new WOW().init();
      },
    },
  ]);
  // 懒加载图片
  lazyLoad();
  initEvent();
  initSwiper();
}
function initEvent() {
  initSearch(".header-search form", ".header-search .toggle");
  fixedsHeader("page__header");
  globalSearch();
  footer1_Init();
  initFancyBox();
  $(".index-1-product-body .list .item").on("click", function () {
    $(this).addClass("active").siblings().removeClass("active");
    $(".content .item").eq($(".index-1-product-body .list .item").index(this)).addClass("actived").siblings().removeClass("actived");
  });
}

function initSwiper() {
  const index_banner = ".index-1-banner";
  new Swiper(`${index_banner} .swiper-container`, {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    speed: 1500,
    autoplay: {
      disableOnInteraction: false,
      delay: 5500,
    },
    loop: true,
    navigation: {
      nextEl: `${index_banner} .next`,
      prevEl: `${index_banner} .prev`,
    },
    pagination: {
      el: `${index_banner} .custom-swiper-pagination`,
      clickable: true,
    },
  });

  const index_news_banner = ".index-1-news-banner ";
  new Swiper(`${index_news_banner} .swiper-container`, {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 30, //间隔
    speed: 1000,
    autoplay: {
      delay: 5000,
    },
    loop: true,
    navigation: {
      nextEl: `${index_news_banner} .next`,
      prevEl: `${index_news_banner} .prev`,
    },
    pagination: {
      el: `${index_news_banner} .swiper-pagination`,
      clickable: true,
    },
  });

  const index_news_banner2 = ".index-1-news-banner2 ";
  new Swiper(`${index_news_banner2} .swiper-container`, {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 3,
    spaceBetween: 30,
    speed: 1000,
    autoplay: {
      delay: 5000,
    },
    loop: true,
    navigation: {
      nextEl: `${index_news_banner2} .swiper-button-next`,
      prevEl: `${index_news_banner2} .swiper-button-prev`,
    },
    pagination: {
      el: `${index_news_banner2} .swiper-pagination`,
      clickable: true,
    },

    breakpoints: {
      320: {
        //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        //当屏幕宽度大于等于768
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        //当屏幕宽度大于等于1280
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
}
